import { displayAdsLog } from '../../utils/debug';

export const LINK_URL = {
    FABRIC: 'https://assets.finn.no/pkg/@fabric-ds/css/v1/fabric.min.css',
    ADVT_CSS: 'CSS_URL_INSERTED_BY_ROLLUP',
};
export function addSButtonSlotToRecommendation(id) {
    if (document) {
        const buttonId = `${id}-button`;
        const slotElem = document.createElement('div');
        slotElem.setAttribute('slot', buttonId);
        const containerElem = document.createElement('div');
        containerElem.setAttribute('id', buttonId);
        slotElem.appendChild(containerElem);

        const recomWc = getRecomWebComponent();
        if (recomWc) {
            recomWc.appendChild(slotElem);
        }
    }
}

export function addSlotToRecommendation(id) {
    if (document) {
        const slotElem = document.createElement('div');
        slotElem.setAttribute('slot', id);
        const containerElem = document.createElement('div');
        containerElem.setAttribute('id', id);
        slotElem.appendChild(containerElem);

        const recomWc = getRecomWebComponent();
        if (recomWc) {
            recomWc.appendChild(slotElem);
        }
    }
}

export const getRecomWebComponent = () => {
    const webComponent =
        document.querySelector('data-podlet-mlt') ||
        document.querySelector('data-podlet-recommend');
    displayAdsLog(`webComponent ${Boolean(webComponent)}`);
    return webComponent;
};
